<div *ngIf="!hidden" class="d-inline-flex align-items-center">
  <span data-test-id="charity-label" [ngClass]="{ inactive: value === 'CHARITY' }" class="me-2">{{
    'HEALTH_FOCUS_LABEAL' | translate
  }}</span>

  <div class="form-check form-switch">
    <input
      type="checkbox"
      class="form-check-input"
      (change)="onToggleChange($event)"
      [disabled]="disabled"
      [checked]="value === 'CHARITY' ? true : false"
      data-test-id="focus-input"
    />
  </div>

  <span data-test-id="health-label" [ngClass]="{ inactive: value === 'HEALTH' }">{{
    'CHARITY_FOCUS_LABEAL' | translate
  }}</span>
</div>
